import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { useTrans } from 'base/utils/i18n';

type ITagProps = {
    className?: string;
    absolute?: boolean;
}
const BundleDealsTag: React.FC<ITagProps> = (props) => {
    const {
        className,
        absolute = false
    } = props
    const { t } = useTrans();

    return (
        <div className={cn(
            'text-center bundle-deals-tag',
            className,
            styles.tag,
            { [styles.absolute]: absolute }
        )}>
            <span>{t('web_tag_bundle_deals')}</span>
        </div>
    )
}

export default BundleDealsTag;